import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { PhoenixObjectDataset } from 'app/model/dataset/phoenix.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'PhoenixSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(PhoenixObjectDataset) }
})
export class PhoenixCopySource extends TabularCopySource {
}
